import React from "react";
import { CgMathMinus, CgMathPlus } from "react-icons/cg";
import styled from "styled-components/macro";
import { colors } from "theme/Theme";

interface CounterProps {
  itemCount: number;
  decrease: (e: any) => void;
  increase: (e: any) => void;
  min?: number;
}

const Counter: React.FC<CounterProps> = ({
  itemCount,
  decrease,
  increase,
  min = 0,
}) => {
  return (
    <CounterContainer aria-label="Количество">
      <CounterButton
        type="button"
        onClick={decrease}
        disabled={itemCount <= min}
        aria-label="Намали количеството"
      >
        <CgMathMinus aria-hidden="true" />
      </CounterButton>
      <Number aria-live="polite">{itemCount}</Number>
      <CounterButton
        type="button"
        onClick={increase}
        aria-label="Увеличи количеството"
      >
        <CgMathPlus aria-hidden="true" />
      </CounterButton>
    </CounterContainer>
  );
};

const CounterContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  align-self: inherit;
`;

const CounterButton = styled.button`
  display: flex;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  color: ${colors.blue};
  background: #ffffff;
  border: 1px solid #c9dce7;
  border-radius: 9px;
  cursor: pointer;

  svg {
    width: 22px;
    height: 22px;
  }

  &:not(:disabled):hover {
    color: #ffffff;
    background: ${colors.blue};
    border-color: ${colors.blue};
  }

  &:focus-visible {
    outline: 3px solid rgba(0, 152, 255, 0.18);
    outline-offset: 2px;
  }

  &:disabled {
    color: ${colors.dark_gray};
    background: ${colors.newGray};
    border-color: ${colors.gray};
    cursor: not-allowed;
  }
`;

const Number = styled.span`
  min-width: 38px;
  color: ${colors.darkest};
  font-size: 1rem;
  font-weight: 700;
  text-align: center;
`;

export default Counter;
